import $ from 'jquery';

const AGENT_KEY = 'agent';
const K_NUMBER_KEY = 'knumber';
const URL_SEPARATOR = '/';
const BEFORE_M_NUMBER = 'ingatlan';
const CENTRAL_AGENT = {
	id: null,
	name: null,
	phone: '+36 1 3 666 456',
	email: 'info@otpip.hu',
	careerLevel: null,
	photoUrl: null,
	central: true
};
const EXCERPT_MAX_LENGTH = 150;

export const RealEstateComponent = {
	transclude: true,
	templateUrl: 'real-estate.html',
	controller: class RealEstateComponenet {
		constructor(RealEstateHandlerService, messagingService, $rootScope, $mdDialog, WebWalkService, seoUtil,
			$timeout, $scope, notificationService, loaderService, $filter) {
			'ngInject';
			this.realEstateService = RealEstateHandlerService;
			this.messagingService = messagingService;
			this.$rootScope = $rootScope;
			this.initData = {};
			this.$mdDialog = $mdDialog;
			this.webWalk = WebWalkService;
			this.seoUtil = seoUtil;
			this.showFullScreenNavigation = true;
			this.showThumbnail = false;
			this.showDescriptionDetails = false;
			this.fullScreenConfig = {
				method: {}
			};
			this.$timeout = $timeout;
			this.$scope = $scope;
			this.notificationService = notificationService;
			this.loaderService = loaderService;
			this.$filter = $filter;
		}

		$onInit() {
			if (!this.initialized) {
				this.initialized = true;
				this.loaderService.show();
				if (window.location.hash) {
					this.paramAgentId = this.parseParam(AGENT_KEY);
					this.kNumber = this.parseParam(K_NUMBER_KEY);
				}
				this.setPagerAnalytics();
				let idFromUrl = this.getIdFromUrl();
				this.realEstateService.getRealEstateDataById(idFromUrl).then(
					(response) => {
						this.loaderService.hide();
						this.realEstateData = response.data.property;
						/*
						// mock a galéria lazy cucchoz
						this.realEstateData.images = [];
						this.realEstateData.images.push(
							{
								url: '/static/assets/sitebuild/img/career-01.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							}, {
								url: '/static/assets/sitebuild/img/career-02.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							}, {
								url: '/static/assets/sitebuild/img/career-03.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							}, {
								url: 'https://www.realestate.com.au/blog/images/1885x1414-fit,progressive/2018/02/26012408/investing-property-with-superannuation_2000x1500.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							}, {
								url: '/static/assets/sitebuild/img/ingatlan-02.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							}, {
								url: '/static/assets/sitebuild/img/ingatlan-03.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							}, {
								url: '/static/assets/sitebuild/img/ingatlan-04.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							}, {
								url: '/static/assets/sitebuild/img/ingatlan-05.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							}, {
								url: 'https://www.propertylife.my/wp-content/uploads/2016/12/Sunway-property-3.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							}, {
								url: 'https://www.hindustantimes.com/rf/image_size_640x362/HT/p2/2016/11/15/Pictures/dream-house-front_8843d09c-ab15-11e6-b961-04ee4fa7b706.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							}, {
								url: 'https://cms.homeaway.com/files/live/sites/hub/files/contributed/homepage/marketing/list-your-property.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							}, {
								url: 'https://www.propertylife.my/wp-content/uploads/2016/12/Sunway-property-3.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							}, {
								url: 'https://d27p8o2qkwv41j.cloudfront.net/wp-content/uploads/2017/08/shutterstock_516637903-e1504758036917.jpg',
								websetaUrl: '',
								isLayout: false,
								isPreview: false
							});

						// ---------------- 1 -------------------------
						response.data.relatedProperties[0].images = [];
						response.data.relatedProperties[0].images.push({
							url: 'https://cms.homeaway.com/files/live/sites/hub/files/contributed/homepage/marketing/list-your-property.jpg',
							websetaUrl: '',
							isLayout: false,
							isPreview: false
						}, {
							url: 'https://www.propertylife.my/wp-content/uploads/2016/12/Sunway-property-3.jpg',
							websetaUrl: '',
							isLayout: false,
							isPreview: false
						}, {
							url: 'https://d27p8o2qkwv41j.cloudfront.net/wp-content/uploads/2017/08/shutterstock_516637903-e1504758036917.jpg',
							websetaUrl: '',
							isLayout: false,
							isPreview: false
						});
						// ---------------- 2 -------------------------
						response.data.relatedProperties[1].images = [];
						response.data.relatedProperties[1].images.push({
							url: '/static/assets/sitebuild/img/ingatlan-05.jpg',
							websetaUrl: '',
							isLayout: false,
							isPreview: false
						}, {
							url: 'https://www.propertylife.my/wp-content/uploads/2016/12/Sunway-property-3.jpg',
							websetaUrl: '',
							isLayout: false,
							isPreview: false
						}, {
							url: 'https://www.hindustantimes.com/rf/image_size_640x362/HT/p2/2016/11/15/Pictures/dream-house-front_8843d09c-ab15-11e6-b961-04ee4fa7b706.jpg',
							websetaUrl: '',
							isLayout: false,
							isPreview: false
						});
						/ ---------------- 3 -------------------------
						response.data.relatedProperties[2].images = [];
						response.data.relatedProperties[2].images.push({
							url: '/static/assets/sitebuild/img/ingatlan-02.jpg',
							websetaUrl: '',
							isLayout: false,
							isPreview: false
						}, {
							url: '/static/assets/sitebuild/img/ingatlan-03.jpg',
							websetaUrl: '',
							isLayout: false,
							isPreview: false
						});
						*/

						// felkészítés thumbnailekre
						this.realEstateData.images = this.$filter('picOrderFilter')(this.realEstateData.images);
						this.realEstateData.thumbnailImages = angular.copy(this.realEstateData.images);


						this.realEstateData.avgPrices = response.data.avgSqPricesByYear;
						this.relatedEstateData = response.data.relatedProperties;
						this.realEstateData.agent = response.data.property.agentData;
						this.relatedEstateData.forEach(e => {
							e.images = this.$filter('picOrderFilter')(e.images);
						});
						this.realEstateData.descriptionTitle = this.getExcerpt(this.realEstateData.propertyData.description);
						this.realEstateData.descriptionDetails = this.realEstateData.propertyData.description;
						this.realEstateLocation = {
							lat: this.realEstateData.propertyData.lat,
							lng: this.realEstateData.propertyData.lng
						};
						this.checkChangeAgent();
						this.checkWebWalk();
						this.webWalk.setWebWalkProperty(this.relatedEstateData);
						this.checkActive();
						this.seoUtil.createEstateSeo(this.realEstateData);
					},
					(error) => {
						if (error.status == 404) {
							this.is404 = true;
							this.notificationService.showInfo({ message: 'unavailableProperty', dontHide: true });
						} else {
							this.notificationService.showError({ message: 'technicalError' });
						}
						this.loaderService.hide(1);
					}
				);
			}
		}

		checkWebWalk() {
			this.webWalk.checkWebWalkForEstate(this.realEstateData);
		}

		checkActive() {
			if (!this.realEstateData.active) {
				this.notificationService.showInfo({ message: 'inactiveProperty' });
			}
		}

		checkChangeAgent() {
			if (this.paramAgentId != false && window.location.hash) {
				this.realEstateService.getAgent(this.paramAgentId).then((response) => {
					this.realEstateData.agent = response.data;
					this.realEstateData = angular.copy(this.realEstateData);
				}).catch(() => {
					// nem sikerült az ügynök csere, megjelenik az eredetivel, vagy ha eredeti sincs, központival
					if (!this.realEstateData.agent || !Object.keys(this.realEstateData.agent).length) {
						this.realEstateData.agent = CENTRAL_AGENT;
						this.realEstateData = angular.copy(this.realEstateData);
					}
				});
			} else if (!this.realEstateData.agent || !Object.keys(this.realEstateData.agent).length) {
				this.realEstateData.agent = CENTRAL_AGENT;
				this.realEstateData = angular.copy(this.realEstateData);
			}
		}

		submitAgentMessageForm(event) {
			this.messagingService.sendMessageToRealEstateAgent(event.message.model, event.message.captcha).then(
				() => {
					// notificationt majd bekötni ha van.
					this.$rootScope.globalNotification = {
						message: 'successShareNotification'
					};
					this.agentMessageFormBackendError = 'success';
				},
				(error) => {
					if (error.status == 422 || error.status == 412) {
						this.notificationService.showError({ message: 'validationError' });
					} else {
						this.notificationService.showError({ message: 'technicalError' });
					}
					this.agentMessageFormBackendError = 'error';
				}
			);
		}

		getExcerpt(text) {
			let excerpt = '';
			if (text.length >= EXCERPT_MAX_LENGTH) {
				excerpt = text.substring(0, EXCERPT_MAX_LENGTH);
				excerpt = excerpt.substring(0, excerpt.lastIndexOf(' '));
				excerpt += '...';
			} else {
				excerpt = text;
			}
			return excerpt;
		}

		clickOnSlide($event) {
			this.currentSlide = $event.currentSlide;
			this.fullScreenGalleryOpen = true;
			this.reInitSliders = true;
			angular.element(window).bind('keydown', (event) => {
				// magic constant :( felfelé nyil.
				if (this.fullScreenGalleryOpen) {
					if (event.which == 40) {
						this.showThumbnail = false;
						this.$scope.$apply();
					}
					if (event.which == 38) {
						this.showThumbnail = true;
						this.$scope.$apply();
					}
					if (event.which == 39) {
						this.fullScreenConfig.method.slickNext();
					}
					if (event.which == 37) {
						this.fullScreenConfig.method.slickPrev();
					}
				}
			});
			this.$mdDialog.show({
				templateUrl: 'fullscreen-gallery-template.html',
				clickOutsideToClose: true,
				controller: () => this,
				controllerAs: '$ctrl',
				onComplete: (scope) => {
					let firstSlide = scope.$ctrl.currentSlide ? scope.$ctrl.currentSlide : 0;
					angular.element('#m19-gallery-full').slick('slickGoTo', firstSlide, false);
					scope.$ctrl.lazyBgImg( true, firstSlide );

					angular.element('#m19-gallery-full').on('afterChange', (event, slick, slide) => {
						scope.$ctrl.currentSlide = slide;
					});
					angular.element('#m19-gallery-full').on('beforeChange', (event, slick, slide, nextSlide) => {
						if (slide != nextSlide) {
							scope.$ctrl.lazyBgImg( angular.element(slick.$slides.get(nextSlide)), nextSlide );
						}
					});
				}
			}).finally(() => {
				angular.element('#m19-main-gallery').slick('slickGoTo', this.currentSlide, false);
				this.fullScreenGalleryOpen = false;
			}).catch(() => { });
		}

		lazyBgImg(element, nextSlide) {
			let vm = this;
			if (element) {
				let lazyBgImgs = angular.element('.lazy-bg-img_' + nextSlide);
				$.each(lazyBgImgs, function (index, el) {
					$(el).css('background-image', 'url(' + vm.realEstateData.images[nextSlide].url + ')');
				});
			}
		}

		setPagerAnalytics() {
			this.$scope.$watch('$ctrl.fullScreenGalleryOpen', newValue => {
				if (newValue) {
					this.$timeout(() => {
						angular.element('.m19-real-estate-gallery .slick-prev').on('click', () => {
							window.dataLayer.push({
								event: 'pageInit',
								pageType: 'Ingatlan végoldal',
								propertyID: this.realEstateData.comissionId
							});
						});
						angular.element('.m19-real-estate-gallery .slick-next').on('click', () => {
							window.dataLayer.push({
								event: 'pageInit',
								pageType: 'Ingatlan végoldal',
								propertyID: this.realEstateData.comissionId
							});
						});
					}, 500);
				}
			});
		}

		closeGallery() {
			this.$mdDialog.cancel();
		}

		goToWebWalk(event) {
			if (event && event.stopPropagation) {
				event.stopPropagation();
			}
			this.realEstateService.sendWebWalk(this.realEstateData.comissionId);
		}

		closeNavigationInfo() {
			this.showFullScreenNavigation = false;
		}

		parseParam(key) {
			let splittedHash = window.location.hash.split('/');
			for (let i = 0; i < splittedHash.length; i++) {
				let elm = splittedHash[i];
				if (elm.indexOf(key) > -1) {
					return elm.substr(elm.indexOf(key) + (key.length + 1));
				}
			}
			return false;
		}

		sendInterest($event) {
			let params = {
				comissionId: this.realEstateData.comissionId,
				interest: $event.interest,
				interestId: this.kNumber
			};
			this.realEstateService.interest(params).then(() => {
				this.interestResponse = 'success';
			}).catch(() => {
				this.interestResponse = 'error';
			});
		}

		getIdFromUrl() {
			let urlArray = window.location.pathname.split(URL_SEPARATOR);
			let index = urlArray.indexOf(BEFORE_M_NUMBER);
			return urlArray[index+1];
		}
	}
};
